import OrderDetails from './modules/order-details/order-details';
import OrderDetailsView from './modules/order-details/order-details.view';

export * from './modules/order-confirmation';
export * from './modules/order-details';
export * from './modules/order-history';
export * from './common';
export * from './actions/get-sales-order-with-hydrations';
export * from './actions/get-tender-types';

export {
    OrderDetails,
    OrderDetailsView
};
